import Icon from '@/components/ui/AppIcon';

const ProcessTimeline = () => {
  const steps = [
    {
      number: 1,
      title: 'Submit Quote Request',
      description: 'Fill out our comprehensive form with your service needs and property details',
      icon: 'DocumentTextIcon',
    },
    {
      number: 2,
      title: 'Receive Quote',
      description: 'Get a detailed quote within 24 hours via your preferred contact method',
      icon: 'CurrencyDollarIcon',
    },
    {
      number: 3,
      title: 'Schedule Service',
      description: 'Choose a convenient time that works with your schedule',
      icon: 'CalendarIcon',
    },
    {
      number: 4,
      title: 'Professional Cleaning',
      description: 'Our expert team arrives on time and transforms your outdoor space',
      icon: 'SparklesIcon',
    },
    {
      number: 5,
      title: 'Final Inspection',
      description: 'Walk through with our team to ensure complete satisfaction',
      icon: 'CheckCircleIcon',
    },
  ];

  return (
    <div className="space-y-6">
      {steps.map((step, index) => (
        <div key={step.number} className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-headline font-bold text-lg">
              {step.number}
            </div>
          </div>
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-2">
              <Icon name={step.icon as any} size={24} className="text-primary" />
              <h3 className="font-headline font-semibold text-lg text-foreground">
                {step.title}
              </h3>
            </div>
            <p className="text-muted-foreground font-body">
              {step.description}
            </p>
          </div>
          {index < steps.length - 1 && (
            <div className="absolute left-6 mt-16 w-0.5 h-12 bg-border" />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProcessTimeline;